export default __webpack_public_path__ + "static/media/discount.ab370cfe.svg";